import { useState } from "react";
import { useAuth } from '../App';

const NAV = [
  {
    section: "OVERVIEW",
    items: [
      { id: "dashboard", label: "Dashboard", icon: IconGrid },
      { id: "bestodds", label: "Best Odds", icon: IconChart },
      { id: "valuebets", label: "Value Bets", icon: IconFire, badge: null, badgeKey: "valueBets" },
      { id: "arbitrage", label: "Arbitrage",  icon: IconArrows, badge: null, badgeKey: "arbs" },
      { id: "heatmap", label: "Heat Map", icon: IconHeat },
      { id: "clv",       label: "CLV Tracker", icon: IconChart },
      { id: 'middles', label: 'Middles', icon: IconMiddle },
      { id: 'sharpMoney', label: 'Sharp Money', icon: IconSharp },
    ]
  },
  {
    section: "TOOLS",
    items: [
      { id: "calculators", label: "Calculators", icon: IconCalc },
      { id: "education", label: "Education", icon: IconBook2 },
      { id: 'smartParlay', label: 'Smart Parlay', icon: IconParlay },
      { id: "bankroll",  label: "Bankroll",    icon: IconWallet },
      { id: "tipsters",  label: "Tipster Hub", icon: IconUsers },
      { id: "telegram",  label: "Telegram Bot", icon: IconTelegram },
    ]
  },
  {
    section: "DATA",
    items: [
      { id: "bookmakers", label: "BW Bookmakers", icon: IconBook },
    ]
  }
];

export default function Sidebar({ currentPage, onNavigate, isOpen }) {
  const { user } = useAuth();
  return (
    <aside style={{
  position: "fixed", left: 0, top: 0, bottom: 0,
  width: 260,
  background: "var(--bg2)",
  borderRight: "1px solid var(--border)",
  display: "flex", flexDirection: "column",
  transform: isOpen ? "translateX(0)" : "translateX(-260px)",
  transition: "transform .25s ease",
  zIndex: 200,
  overflow: "hidden",
}}>
      {/* Brand */}
      <div style={{ padding: "24px 20px 20px", borderBottom: "1px solid var(--border)" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <svg width="28" height="28" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
  <circle cx="32" cy="32" r="30" stroke="#00e5b0" strokeWidth="3"/>
  <circle cx="32" cy="32" r="19" stroke="#00e5b0" strokeWidth="1.5" opacity="0.35"/>
  <circle cx="32" cy="32" r="6" fill="#00e5b0"/>
  <line x1="32" y1="2" x2="32" y2="12" stroke="#00e5b0" strokeWidth="3" strokeLinecap="round"/>
  <line x1="32" y1="52" x2="32" y2="62" stroke="#00e5b0" strokeWidth="3" strokeLinecap="round"/>
  <line x1="2" y1="32" x2="12" y2="32" stroke="#00e5b0" strokeWidth="3" strokeLinecap="round"/>
  <line x1="52" y1="32" x2="62" y2="32" stroke="#00e5b0" strokeWidth="3" strokeLinecap="round"/>
  <line x1="11" y1="11" x2="17" y2="17" stroke="#00e5b0" strokeWidth="2" strokeLinecap="round" opacity="0.45"/>
  <line x1="53" y1="11" x2="47" y2="17" stroke="#00e5b0" strokeWidth="2" strokeLinecap="round" opacity="0.45"/>
  <line x1="11" y1="53" x2="17" y2="47" stroke="#00e5b0" strokeWidth="2" strokeLinecap="round" opacity="0.45"/>
  <line x1="53" y1="53" x2="47" y2="47" stroke="#00e5b0" strokeWidth="2" strokeLinecap="round" opacity="0.45"/>
</svg>
<div>
  <div style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: 14, color: "var(--text)", letterSpacing: 1 }}>
    ODDSEDGE<span style={{ color: "#3d8ef8", marginLeft: 6 }}>BW</span>
  </div>
  <div style={{ fontSize: 9, color: "var(--text3)", letterSpacing: 2, textTransform: "uppercase", marginTop: 1 }}>
    Betting Intelligence
  </div>
</div>
        </div>
      </div>

      {/* Navigation */}
      <nav style={{ flex: 1, overflowY: "auto", padding: "12px 0" }}>
        {NAV.map(group => (
          <div key={group.section}>
            <div style={{
              padding: "10px 20px 4px",
              fontSize: 9, letterSpacing: 1.5,
              textTransform: "uppercase",
              color: "var(--text3)",
              fontFamily: "var(--font-display)",
            }}>
              {group.section}
            </div>
            {group.items.map(item => {
              const Icon = item.icon;
              const active = currentPage === item.id;
              return (
                <button
                  key={item.id}
                  onClick={() => onNavigate(item.id)}
                  style={{
                    display: "flex", alignItems: "center", gap: 10,
                    padding: "9px 12px 9px 16px",
                    margin: "1px 8px",
                    width: "calc(100% - 16px)",
                    borderRadius: "var(--radius-sm)",
                    background: active ? "rgba(0,229,176,0.1)" : "transparent",
                    border: active ? "1px solid rgba(0,229,176,0.2)" : "1px solid transparent",
                    color: active ? "var(--accent)" : "var(--text2)",
                    fontSize: 13,
                    fontFamily: "var(--font-body)",
                    fontWeight: active ? 600 : 400,
                    transition: "all .12s",
                    cursor: "pointer",
                    textAlign: "left",
                  }}
                  onMouseEnter={e => { if (!active) { e.currentTarget.style.background = "var(--bg3)"; e.currentTarget.style.color = "var(--text)"; }}}
                  onMouseLeave={e => { if (!active) { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "var(--text2)"; }}}
                >
                  <Icon size={15} />
                  <span style={{ flex: 1 }}>{item.label}</span>
                  {item.badge != null && (
                    <span style={{
                      fontSize: 10, fontWeight: 700,
                      background: "var(--accent)", color: "#080d17",
                      padding: "1px 6px", borderRadius: 10,
                      fontFamily: "var(--font-display)",
                    }}>{item.badge}</span>
                  )}
                </button>
              );
            })}
          </div>
        ))}
      </nav>

      {/* Admin section — only visible to admins */}
{user?.role === 'admin' && (
  <div>
    <div style={{
      padding: "10px 20px 4px",
      fontSize: 9, letterSpacing: 1.5,
      textTransform: "uppercase",
      color: "var(--text3)",
      fontFamily: "var(--font-display)",
    }}>
      Admin
    </div>
    {[{ id: 'admin', label: 'Admin Panel', icon: IconSettings }].map(item => {
      const Icon = item.icon;
      const active = currentPage === item.id;
      return (
        <button
          key={item.id}
          onClick={() => onNavigate(item.id)}
          style={{
            display: "flex", alignItems: "center", gap: 10,
            padding: "9px 12px 9px 16px",
            margin: "1px 8px",
            width: "calc(100% - 16px)",
            background: active ? "rgba(0,229,176,0.08)" : "transparent",
            border: "none",
            borderRadius: "var(--radius-sm)",
            cursor: "pointer",
            color: active ? "var(--accent)" : "var(--text2)",
          }}
        >
          <Icon size={16} />
          <span style={{ fontSize: 13, fontWeight: active ? 600 : 400 }}>{item.label}</span>
        </button>
      );
    })}
  </div>
)}

{/* Telegram CTA */}

      {/* Telegram CTA */}
      <div style={{ padding: "12px 10px", borderTop: "1px solid var(--border)" }}>
        <button
          onClick={() => window.open("https://t.me/OddsEdgeBW_bot", "_blank")}
          style={{
            width: "100%",
            display: "flex", alignItems: "center", gap: 10,
            padding: "10px 12px",
            background: "rgba(61,142,248,0.08)",
            border: "1px solid rgba(61,142,248,0.2)",
            borderRadius: "var(--radius-sm)",
            cursor: "pointer",
            transition: "background .15s",
          }}
          onMouseEnter={e => e.currentTarget.style.background = "rgba(61,142,248,0.14)"}
          onMouseLeave={e => e.currentTarget.style.background = "rgba(61,142,248,0.08)"}
        >
          <div style={{
            width: 28, height: 28,
            background: "#2196F3", borderRadius: "50%",
            display: "flex", alignItems: "center", justifyContent: "center",
            flexShrink: 0,
          }}>
            <IconTelegram size={14} color="#fff" />
          </div>
          <div>
            <div style={{ fontSize: 11, fontWeight: 600, color: "var(--accent2)", fontFamily: "var(--font-display)" }}>
              @OddsEdgeBW_bot
            </div>
            <div style={{ fontSize: 10, color: "var(--text3)" }}>Connect Telegram</div>
          </div>
        </button>
      </div>
    </aside>
  );
}

// ─── Icons (inline SVG components) ───────────────────────────────────────────
function Ico({ size = 16, children, ...props }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" {...props}>
      {children}
    </svg>
  );
}
function IconGrid({ size }) { return <Ico size={size}><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></Ico>; }
function IconFire({ size }) { return <Ico size={size}><path d="M12 2c0 0-4 5-4 9a4 4 0 0 0 8 0c0-4-4-9-4-9z"/><path d="M12 17c-1.1 0-2-.9-2-2 0-1.5 2-4 2-4s2 2.5 2 4c0 1.1-.9 2-2 2z"/></Ico>; }
function IconArrows({ size }) { return <Ico size={size}><path d="M7 16V4m0 0L3 8m4-4 4 4M17 8v12m0 0 4-4m-4 4-4-4"/></Ico>; }
function IconChart({ size }) { return <Ico size={size}><polyline points="22,12 18,12 15,21 9,3 6,12 2,12"/></Ico>; }
function IconMiddle({ size }) { return <Ico size={size}><path d="M12 2v20M2 12h20M7 7l10 10M17 7L7 17"/></Ico>; }
function IconSharp({ size }) { return <Ico size={size}><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></Ico>; }
function IconHeat({ size }) { return <Ico size={size}><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M3 15h18M9 3v18M15 3v18"/></Ico>; }
function IconParlay({ size }) { return <Ico size={size}><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></Ico>; }
function IconCalc({ size }) { return <Ico size={size}><rect x="4" y="2" width="16" height="20" rx="2"/><line x1="8" y1="6" x2="16" y2="6"/><line x1="8" y1="10" x2="16" y2="10"/><line x1="8" y1="14" x2="12" y2="14"/></Ico>; }
function IconWallet({ size }) { return <Ico size={size}><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M16 12h2"/></Ico>; }
function IconBook2({ size }) { return <Ico size={size}><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></Ico>; }
function IconUsers({ size }) { return <Ico size={size}><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/></Ico>; }
function IconSettings({ size }) { return <Ico size={size}><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></Ico>; }
function IconTelegram({ size, color }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color || "currentColor"}>
      <path d="M9.78 18.65l.28-4.23 7.68-6.92c.34-.31-.07-.46-.52-.19L7.74 13.3 3.64 12c-.88-.25-.89-.86.2-1.3l15.97-6.16c.73-.33 1.43.18 1.15 1.3l-2.72 12.81c-.19.91-.74 1.13-1.5.71L12.6 16.3l-1.99 1.93c-.23.23-.42.42-.83.42z"/>
    </svg>
  );
}
function IconBook({ size }) { return <Ico size={size}><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></Ico>; }
